<template>
    <b-form @submit.prevent="openModalConfirm">
        <div class="form-parameter-wrapper">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Admin Elektronik" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="biayaAdminInput.ADM_ELEK" id="adminElekPersen" name="adminElektronik" step="0.01" @blur="roundPersen(1)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="adminElekPersen" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Biaya admin yang dikenakan di awal dan perpanjangan gadai elektronik</span>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="biayaAdminInput.ADM_ELEK_MIN" name="minAdminElektronik" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum biaya admin</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Admin Kendaraan" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="biayaAdminInput.ADM_KEND" id="adminKendPersen" name="adminKendaraan" step="0.01" @blur="roundPersen(2)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="adminKendPersen" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Biaya admin yang dikenakan di awal dan perpanjangan gadai kendaraan</span>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="biayaAdminInput.ADM_KEND_MIN" name="minAdminKendaraan" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum biaya admin</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Admin Awal BPKB" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="biayaAdminInput.ADM_BPKB_AWAL" id="adminBpkbAwalPersen" name="adminBpkbAwal" step="0.01" @blur="roundPersen(3)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="adminBpkbAwalPersen" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Biaya admin yang dikenakan di awal gadai BPKB</span>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="biayaAdminInput.ADM_BPKB_AWAL_MIN" name="minAdminBpkbAwal" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum biaya admin</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Admin Bulanan BPKB" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="biayaAdminInput.ADM_BPKB_BULANAN" id="adminBpkbBulananPersen" name="adminBpkbBulanan" step="0.01" @blur="roundPersen(4)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="adminBpkbBulananPersen" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Biaya admin yang dikenakan setiap bulan untuk gadai BPKB</span>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="biayaAdminInput.ADM_BPKB_BULANAN_MIN" name="minAdminBkpbBulanan" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum biaya admin</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Minimum Admin Jenis TV" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="biayaAdminInput.ADM_TV_MIN" name="minAdminTv" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum biaya admin untuk penggadaian TV</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Biaya Asuransi" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="biayaAdminInput.ADM_PAYJOY_REGIS" name="biayaRegisPayJoy" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Biaya asuransi yang dikenakan saat awal gadai, untuk cabang yang menggunakan / mengaktifkan biaya asuransi</span>
                    </b-col>
                </b-row>
            </b-form-group>
        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
            <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
        </div>
        <ModalConfirm id="modal-edit-biayaAdmin" title="Confirm Edit Parameter Biaya Admin" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah parameter biaya admin ini?" @submit="onSubmit" />
    </b-form>
</template>

<script>
export default {
    name: 'biaya-admin',
    props: {
        biayaAdminInput: { type: Object, required: true }
    },
    data(){
        return{
            isSubmitting: false,
            newData: {}
        }
    },
    watch: {
        "biayaAdminInput.ADM_ELEK_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.biayaAdminInput.ADM_ELEK_MIN = result);
        },
        "biayaAdminInput.ADM_KEND_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.biayaAdminInput.ADM_KEND_MIN = result);
        },
        "biayaAdminInput.ADM_BPKB_AWAL_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.biayaAdminInput.ADM_BPKB_AWAL_MIN = result);
        },
        "biayaAdminInput.ADM_BPKB_BULANAN_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.biayaAdminInput.ADM_BPKB_BULANAN_MIN = result);
        },
        "biayaAdminInput.ADM_TV_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.biayaAdminInput.ADM_TV_MIN = result);
        },
        "biayaAdminInput.ADM_PAYJOY_REGIS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.biayaAdminInput.ADM_PAYJOY_REGIS = result);
        },
    },
    methods: {
        //----------------- Fungsi Submit Data -----------------

        onSubmit() {

            this.newData = JSON.parse(JSON.stringify(this.biayaAdminInput))
            
            const minAdminElektronik = this.$helper.removeThousandSeparator(this.newData.ADM_ELEK_MIN);
            this.newData.ADM_ELEK_MIN = minAdminElektronik;
            const minAdminKendaraan = this.$helper.removeThousandSeparator(this.newData.ADM_KEND_MIN);
            this.newData.ADM_KEND_MIN = minAdminKendaraan;
            const minAdminBpkbAwal = this.$helper.removeThousandSeparator(this.newData.ADM_BPKB_AWAL_MIN);
            this.newData.ADM_BPKB_AWAL_MIN = minAdminBpkbAwal;
            const minAdminBkpbBulanan = this.$helper.removeThousandSeparator(this.newData.ADM_BPKB_BULANAN_MIN);
            this.newData.ADM_BPKB_BULANAN_MIN = minAdminBkpbBulanan;
            const minAdminTv = this.$helper.removeThousandSeparator(this.newData.ADM_TV_MIN);
            this.newData.ADM_TV_MIN = minAdminTv;
            const biayaRegisPayJoy = this.$helper.removeThousandSeparator(this.newData.ADM_PAYJOY_REGIS);
            this.newData.ADM_PAYJOY_REGIS = biayaRegisPayJoy;

            let payload = new FormData()
            
            for (let [key, value] of Object.entries(this.newData)) {
                payload.append("name", key)
                payload.append("value", value)
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("parameter/update/", payload).then(response => {
                this.$helper.toastSucc(this, "Parameter Biaya Admin telah berhasil diubah!")
                this.$bvModal.hide("modal-edit-biayaAdmin")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
        
        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
        
        openModalConfirm(){
            this.$bvModal.show("modal-edit-biayaAdmin")
        },

        roundPersen(id){
            if(id == 1){
                var adminElektronik = Number(this.biayaAdminInput.ADM_ELEK).toFixed(2);
                this.biayaAdminInput.ADM_ELEK = adminElektronik;
            }else if(id == 2){
                var adminKendaraan = Number(this.biayaAdminInput.ADM_KEND).toFixed(2);
                this.biayaAdminInput.ADM_KEND = adminKendaraan;
            }else if(id == 3){
                var adminBpkbAwal = Number(this.biayaAdminInput.ADM_BPKB_AWAL).toFixed(2);
                this.biayaAdminInput.ADM_BPKB_AWAL = adminBpkbAwal;
            }else{
                var adminBpkbBulanan = Number(this.biayaAdminInput.ADM_BPKB_BULANAN).toFixed(2);
                this.biayaAdminInput.ADM_BPKB_BULANAN = adminBpkbBulanan;
            }
        }
    },
    created(){
    }
}
</script>